<template>
  <div class="compltProp">
    <div v-if="step === 1">
      <div class="title">用户意见反馈</div>
      <div class="segment-outer">
        <div class="segment-header">用户意见反馈</div>
        <div class="pl-16">
          <div>尊敬的用户：</div>
          <div class="pl-26">
            <div class="contain mt-16">
              您好。<br />感谢您选择司机宝。请将您对司机宝平台的意见和建议告诉我们，以便我们为您提供更好的服务。感谢您的支持。
            </div>
            <div class="flex mt-10">
              <div class="complt-desc">问题类型：</div>
              <template>
                <el-radio v-model="problemRadio" label="1">功能故障</el-radio>
                <el-radio v-model="problemRadio" label="2">服务质量</el-radio>
                <el-radio v-model="problemRadio" label="0">其他</el-radio>
              </template>
            </div>
            <div class="com-textarea">
              <el-input
                type="textarea"
                placeholder="请输入您的投诉与意见（限140个字符）"
                v-model.trim="complDesc"
                :rows="4"
                :maxlength="140"
              >
              </el-input>
            </div>
            <div class="mt-10">
              <fe-upload :default-files="imgUrlList" :limit="5" :hidetip="true" ref="uploadImg" />
            </div>
          </div>
        </div>
      </div>
      <div class="ml-50 mb-20">
        <el-button type="primary" plain @click="goBack">返回</el-button>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </div>
    </div>
    <div v-else class="wd-100">
      <img src="../../assets/img/setting/ico_suc.png" alt="" class="success-icon" />
      <div class="success-tips">提交成功</div>
      <div class="success-time">感谢您的反馈，我们将于3日内联系您，协助您解决问题。</div>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:2
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import FeUpload from '@/components/FeUpload';
import axiosNew from '@/api/axiosNew';
import newApi from '@/api/settings.new.api';
import cfg from '@/assets/js/config';
export default {
  data() {
    return {
      step: 1,
      appCode: `${cfg.appcode}`,
      problemRadio: '2',
      complDesc: '',
      imgUrlList: []
    };
  },
  components: {
    FeUpload
  },
  methods: {
    goBack() {
      window.location.go(-1);
    },
    submitForm() {
      if (!this.complDesc) {
        this.$message.error('请输入您的投诉与意见');
        return;
      }
      axiosNew
        .post(newApi.createComplaintAndSuggestion, {
          appCode: this.appCode,
          type: parseInt(this.problemRadio),
          commentContent: this.complDesc,
          url: this.$refs.uploadImg.getUploadFiles().toString()
        })
        .then(res => {
          this.step++;
        });
    }
  }
};
</script>

<style scoped>
.title {
  margin-left: 16px;
  padding-top: 24px;
  padding-bottom: 12px;
  font-size: 14px;
  color: #99a9bf;
}
.pl-16 {
  padding-left: 16px;
}
.pl-26 {
  padding-left: 26px;
}
.mt-16 {
  margin-top: 16px;
}
.contain {
  line-height: 36px;
}
.flex {
  display: flex;
  align-items: center;
}
.mt-10 {
  margin-top: 10px;
}
.complt-desc {
  /* margin-top: 10px; */
  margin-right: 4px;
}
.com-textarea {
  width: 927px;
  height: 106px;
  margin-top: 20px;
}
.ml-50 {
  margin-left: 50px;
}
.success-icon {
  position: absolute;
  left: calc(50vw + 80px);
  top: 222px;
}
.success-tips {
  margin-top: 337px;
  text-align: center;
  font-size: 18px;
  color: #424b53;
}
.success-time {
  font-size: 14px;
  text-align: center;
  color: #999999;
}
</style>
